import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";
import React from "react";
import { sumCentsAmountToDolar } from "utils/tools";

interface ICostCalculationPreviewProp {
  resultCalculationTransactions: IResultCalculationItem[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const CostCalculationPreview = ({
  resultCalculationTransactions,
}: ICostCalculationPreviewProp) => {
  const classes = useStyles();
  const format = "DD/MM/YY";

  return (
    // <>
    //   <Grid item xs={12}>
    //     <Typography variant="h5">{labelSection}</Typography>
    //   </Grid>
    //   {resultCalculations.map((resultCalculation: any) => (
    //     <Grid item xs={12}>
    //       <Typography variant="h6">
    //         Cost Preview for Rate Chart #{resultCalculation.rateChart.id} -{" "}
    //         {resultCalculation.rateChart.name}
    //       </Typography>

    //     </Grid>
    //   ))}
    // </>
    <TableContainer>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCell>Schedule Date</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {resultCalculationTransactions.map(
            (item: IResultCalculationItem, i: number) => {
              return (
                <TableRow key={i}>
                  <TableCell>
                    {moment.utc(item.fromDate).format(format)} -{" "}
                    {moment.utc(item.toDate).format(format)}
                  </TableCell>
                  <TableCell>$ {item.total.toFixed(2) / 100}</TableCell>
                </TableRow>
              );
            }
          )}

          <TableRow>
            <TableCell>Total :</TableCell>
            <TableCell>
              $ {sumCentsAmountToDolar(resultCalculationTransactions)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CostCalculationPreview;
